export const NOT_AUTHENTICATED = 'NOT_AUTHENTICATED';
export const NOT_AUTHORIZED = 'NOT_AUTHORIZED';
export const EXPIRED_SESSION = 'EXPIRED_SESSION';
